<template>
    <popup
        v-show="patientPopupNotes ? patientPopupNotes.show : false"
        :list="patientPopupNotes ? patientPopupNotes.list : []"
        :show-number="false"
        @hide="$store.commit('patient/hidePopupNotes')"
    >
    </popup>
</template>

<script>
export default {
    name: "patient-popup-notes",
    components: {
        Popup: () => import("@/components/elements/popup")
    },
    computed: {
        patientPopupNotes() {
            return this.$store.getters["patient/popupNotes"];
        }
    }
};
</script>
